<template>
  <div id="app">
    <div ref="all" class="all">
      <header class="header">
        <nav class="nav">
          <div class="nav_main">
            <div v-html="headerData.logo" class="logo"></div>
            <ul class="logo_right">
              <li v-for="(item,index) in headerData.logoRight" :key="index">
                <a :href="item.href" :target="index==4?'_blank':'_self'" :ref="`logoRightLi${index+1}`" @click="handleHeaderClick(index+1)" v-html="item.title"></a>
              </li>
            </ul>
          </div>
        </nav>
        <main class="header_main">
          <h1>{{headerData.main.h1}}</h1>
          <p>{{headerData.main.p}}</p>
          <div class="btn">
            <a v-for="(item,index) in headerData.main.btnData"
               :key="index"
               :href="item.href"
               :target="index==1?'_blank':'_self'"
               :class="`aBtnClass btn${index+1}`">
              {{item.title}}
            </a>
          </div>
        </main>
      </header>

      <div id="service" class="service">
        <p class="h1">{{serviceData.h1}}</p>
        <p class="p">{{serviceData.p}}</p>
        <main class="main">
          <ul class="mainUl">
            <li v-for="(item,index) in serviceData.main"
                :key="index"
                @click="handleClick(index+1)"
                :class="sService==index+1?'sActive':''">
              <span :class="item.icon"></span>
              {{item.title}}
            </li>
          </ul>
          <section class="sContent">
            <transition v-for="(item,index) in serviceData.content" :key="index" name="fade">
              <ul v-if="sService==(index+1)" class="hr">
                <li v-for="(i,idx) in item"
                    :key="idx" @click="handleClickHrLi(idx+1)"
                    :class="hrLiActive==idx+1?'hrActiveXXX':''">
                  <div class="icon iconfont icon-complete"></div>
                  <span class="title">{{i.title}}</span>
                  <p>{{i.p}}</p>
                </li>
              </ul>
            </transition>
          </section>
        </main>
        <a class="aBtnClass swzx" href="#footer">商务咨询</a>
      </div>

      <div id="solution" class="solution">
        <p class="solution_title">行业解决方案</p>
        <ul class="solution_ul">
          <li v-for="(item,index) in solutionData.main" :key="index"
              @click="handleClickSolution(index+1,item.text)" class="solution_li" :class="solutionActive==index+1?'solution_li_active':''">
            <div class="icon">
              <img :class="`img${index+1}`" src="./assets/icon_solution.png"/>
            </div>
            <p>{{item.title}}</p>
          </li>
        </ul>
        <div class="solution_content">
          <p>{{solutionData.contentText}}</p>
        </div>
        <a class="aBtnClass swzx" href="#footer">商务咨询</a>
      </div>

      <div id="liaison" class="liaison">
        <p class="liaison_title">{{liaisonData.title}}</p>
        <main class="liaison_main">
          <aside class="liaison_main_aside liaison_main_left">
            <div class="leftTop">
              <p>{{liaisonData.main.leftTop.title}}</p>
              <p>{{liaisonData.main.leftTop.content}}</p>
            </div>
            <div class="leftBot">
              <p>{{liaisonData.main.leftBot.title}}</p>
              <p>{{liaisonData.main.leftBot.content}}</p>
            </div>
          </aside>
          <section class="liaison_main_center"></section>
          <aside class="liaison_main_aside liaison_main_right">
            <div class="rightTop">
              <p>{{liaisonData.main.rightTop.title}}</p>
              <p>{{liaisonData.main.rightTop.content}}</p>
            </div>
            <div class="rightBot">
              <p>{{liaisonData.main.rightBot.title}}</p>
              <p>{{liaisonData.main.rightBot.content}}</p>
            </div>
          </aside>
        </main>
      </div>

      <div class="adBox">
        <div class="ad">
          <div class="ad_left">
            <p class="ad_left_title">安全、便捷、高效的产品服务</p>
            <a class="aBtnClass contactUs" href="#footer">联系我们</a>
          </div>
          <div class="ad_right">
            <ul>
              <li><p>7000+</p><p>用户选择Elite</p></li>
              <li><p>700+</p><p>研发团队</p></li>
              <li><p><span>持续</span>为客户</p><p>版本更新</p></li>
            </ul>
          </div>
        </div>
      </div>

      <footer id="footer" class="footer">
        <main class="footer_main">
          <div class="foot_left">
            <div class="left_title">
              <img src="./assets/logo_elite.png"/>
              关于过河兵
            </div>
            <div v-html="footerData.aboutText"></div>
          </div>
          <div class="foot_right">
            <div class="right_title">
              联系我们
            </div>
            <div class="right_content">
              <p><span class="iconfont icon-call"></span>021 64516261</p>
              <div v-for="(item,index) in footerData.telData" :key="index">
                <p style="white-space:nowrap;margin-top:15px;">
                  <span style="display:inline-block;width:60px;"><span class="iconfont" v-html="nameSVG" style="position: relative;top: 2px;"></span>{{item.name}}</span>
                  <span style="display:inline-block;margin: 0px 7px;"><span class="iconfont icon-call"></span>{{item.tel}}</span>
                  <span><span class="iconfont" style="position: relative;top: 2px;" v-html="emailSVG"></span>{{item.email}}</span>
                </p>
              </div>
            </div>
          </div>
        </main>
        <div class="foo">
            {{footerData.fooText}}
        </div>
      </footer>

    </div>

  </div>
</template>
<script>
import '../assets/iconfont/font_2696663_pmpbu9nnw6p/iconfont.css';
import './app.less';
export default {
  name: 'App',
  data(){
    return {
      sService:'1',
      hrLiActive:'1',
      solutionActive:'1',
      headerData:{
        logo:`<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="_x31_" x="0px" y="0px" viewBox="0 0 204 42" style="enable-background:new 0 0 204 42;" xml:space="preserve">
         <path id="Fill-3" class="st0" d="M103.447,19.914h-5.948v-4.319h5.316v-2.711h-2.846l2.121-3.659h-3.103l-2.121,3.659h-1.464  l-2.121-3.659h-3.103l2.121,3.659h-3.184v2.711h5.316v4.319h-5.948v2.725h5.422c-0.438,3.196-2.519,6.151-5.42,7.603v2.927  c4.054-1.552,6.445-4.773,7.481-7.805c1.064,3.069,3.445,6.249,7.481,7.805v-2.927c-2.901-1.452-4.983-4.407-5.42-7.603h5.422  V19.914z M63.776,15.347h-3.083c-2.295,3.848-6.27,6.481-11.366,6.481v2.796c0,0,1.711,0.046,3.642-0.406v8.832H71.5v-8.832  c1.931,0.452,3.642,0.406,3.642,0.406v-2.796C70.047,21.828,66.072,19.194,63.776,15.347L63.776,15.347z M155.088,14.897  l1.685,5.171h-3.769l-1.685-5.171H155.088z M153.004,21.139l3.769-0.003c0,3.129-0.841,8.799-2.372,11.903h-4.078  C151.883,30.033,153.092,24.485,153.004,21.139L153.004,21.139z M111.057,23.659h3.93v-3.932h-3.93V23.659z M80.912,23.668h3.633  v2.898l-3.633,0.968V23.668z M80.912,21.092h3.633v-3.101h-3.633V21.092z M80.912,15.208h3.633v-3.101h-3.633V15.208z M77.233,9.396  v2.711h0.912v16.148l-0.912,0.259v0.038v2.874l7.313-1.96v3.707h2.767v-4.443l0.865-0.238v-2.891l-0.865,0.237V12.107h0.865v-0.072  V9.396H77.234H77.233z M132.441,30.054h15.504v3.075h-16.209c-1.974,0-3.802-0.593-4.742-1.779  c-0.953,1.018-2.375,1.572-4.213,1.822v-2.853c1.364-0.499,2.969-1.286,2.94-2.469V17.256h-2.94v-2.971h6.304v12.326  C129.177,28.813,130.297,29.96,132.441,30.054L132.441,30.054z M183.446,22.721h13.366v-4.522h-13.366V22.721z M200.074,22.721  v-4.522h1.945v-2.881h-18.572v-2.837l18.572-0.455V8.934l-21.834,0.531v13.255h-1.945v2.881h25.723v-2.881H200.074z M156.773,8.997  h19.415v2.971h-1.743v21.203h-10.333V30.2h6.965V11.968h-14.304V8.997z M161.61,25.206h4.478v-7.904h-4.478V25.206z M158.919,28.088  h10.18V14.419h-10.18V28.088z M199.672,27.004h-4.298c1.28,2.296,4.29,4.946,7.586,6.167v-3.709  C201.723,28.838,200.635,27.983,199.672,27.004L199.672,27.004z M182.531,27.004h4.298c-1.28,2.296-4.289,4.946-7.586,6.167v-3.709  C180.479,28.838,181.568,27.983,182.531,27.004L182.531,27.004z M50.271,16.635v2.803c4.48,0,7.792-2.528,9.561-5.696h-3.364  C55.004,15.475,52.722,16.718,50.271,16.635L50.271,16.635z M74.198,16.635v2.803c-4.48,0-7.791-2.528-9.561-5.696h3.364  C69.465,15.475,71.748,16.718,74.198,16.635L74.198,16.635z M125.316,12.911l-1.386-4.253h3.769l1.386,4.253H125.316z   M152.008,13.829l-1.685-5.171h3.769l1.684,5.171H152.008z M142.152,12.911h-12.231V9.94h12.231V8.658h3.364V9.94h1.895v2.972  h-1.895v15.421h-11.951v-2.971h8.587V12.911z M135.195,22.721l-2.401-7.371h3.761l2.401,7.371H135.195z M49.705,14.68v-2.235V9.702  h10.404V8.584h4.251v1.118h10.404v4.978H71.66v-2.235H52.81v2.235H49.705z M55.739,23.301c2.568-1.127,4.841-2.945,6.499-5.224  c1.658,2.279,3.93,4.097,6.499,5.224H55.739z M56.075,30.308h12.321v-4.263H56.075V30.308z M18.607,41.708  c-0.878,0-1.755-0.226-2.538-0.679L2.537,33.214C0.972,32.31,0,30.625,0,28.817V13.185c0-1.808,0.972-3.493,2.537-4.397L16.07,0.971  c1.565-0.904,3.509-0.904,5.075,0l13.532,7.816c1.565,0.905,2.537,2.59,2.537,4.397v17.234c0,0.934-0.757,1.692-1.692,1.692  c-0.934,0-1.692-0.758-1.692-1.692V13.185c0-0.603-0.324-1.165-0.846-1.466L19.453,3.902c-0.521-0.302-1.17-0.302-1.692,0  L4.229,11.719c-0.522,0.301-0.846,0.863-0.846,1.466v15.633c0,0.602,0.324,1.164,0.846,1.466l13.532,7.816  c0.522,0.302,1.17,0.301,1.691,0l6.767-3.909c0.522-0.302,0.846-0.863,0.846-1.466V17.092c0-0.602-0.324-1.164-0.846-1.466  l-6.766-3.908c-0.521-0.302-1.17-0.302-1.692,0l-6.766,3.908c-0.522,0.302-0.846,0.863-0.846,1.466v7.816  c0,0.602,0.324,1.164,0.846,1.466l4.465,2.579c0.809,0.467,1.086,1.502,0.619,2.312c-0.467,0.809-1.501,1.087-2.311,0.619  l-4.465-2.579c-1.565-0.904-2.537-2.589-2.537-4.397v-7.816c0-1.808,0.972-3.493,2.537-4.397l6.766-3.909  c1.565-0.904,3.509-0.904,5.075,0l6.766,3.909c1.565,0.904,2.537,2.589,2.537,4.397v15.633c0,1.808-0.972,3.493-2.537,4.397  l-6.766,3.908C20.362,41.482,19.485,41.708,18.607,41.708"/>
         </svg>`,
        logoRight:[
          {title:'首页',href:'#'},
          {title:'行业解决方案',href:'#solution'},
          {title:'技术支持',href:'#liaison'},
          {title:'关于我们',href:'#footer'},
          {title:'<div class="wsgd"></div>网上工单',href:'http://dev.elitecrm.com/ngs/login?mode=1&ds=EliteCRM'},
        ],
        main:{
          h1:'过河兵呼叫中心&CRM',
          p:'智能化营销系统、数字化运营管理平台',
          btnData:[
            {title:'商务咨询',href:'#footer'},
            {title:'加入我们',href:'https://www.zhipin.com/gongsir/f0682137f4215b9c1nd_3t0~.html?ka=sel_city_0'}
          ]
        }
      },//导航条
      serviceData: {
        h1: '营销化、智能化、数字化、移动化产品服务',
        p: '快速解决企业营销转化低，服务监管难，客户数据管理乱等问题',
        main: [
          {title: '呼入', icon: 'iconfont icon-callin'},
          {title: '呼出', icon: 'iconfont icon-callout'},
          {title: '系统管理', icon: 'iconfont icon-management'},
          {title: '监控及报表', icon: 'iconfont icon-report'},
          {title: '系统集成', icon: 'iconfont icon-integrated'},
          {title: '智能化赋能', icon: 'iconfont icon-intelligence'},
        ],
        content: [
          [//呼入
            {title:'来电弹屏',p:'来电全流程/轨迹坐席辅助'},
            {title:'客户信息管理',p:'从线索到转化的智能跟踪，精准营销'},
            {title:'账户查询',p:'多种查询条件，来电号码默认带入'},
            {title:'咨询、投诉工单',p:'强大的工单系统，让客户服务更及时'},
            {title:'短信、邮件应用',p:'支持与三方短信平台、邮件系统集成'},
            {title:'业务办理',p:'高效处理账单查询、挂失等金融业务'},
          ],
          [//呼出
            {title:'回访问卷',p:'统一制定问题话术规则保障回访质量'},
            {title:'名单数据管理',p:'内部抽取、外部导入、实时接收'},
            {title:'工作台、驾驶舱',p:'个人工作台、领导驾驶舱'},
            {title:'移动端菜单',p:'呼客户信息展现、接触记录、商机信息维护、APP消息推送、销售日周报、名片扫描出'},
            {title:'消息提醒和待办任务',p:'系统内消息、移动端消息推送，待办和已办任务'},
            {title:'客户管理',p:'列表、摘要、标签、关系图谱、背景图、联系人、服务记录、商机管理、签约管理、附件资料、服务团队'}
          ],
          [//系统管理
            {title:'用户账号及权限管理',p:'设置不同组不同角色查看的页面权限不同'},
            {title:'知识库',p:'专业知识、常件问题汇总更好帮助坐席解决日常用户问题，提升坐席技能水平'},
            {title:'质检管理',p:'录音质检、工单质检、网聊质检'},
            {title:'公告管理',p:'强制提醒、跑马灯通知'},
            {title:'考试管理',p:'针对坐席进行专项培训考试，提升坐席技能'},
            {title:'开机提示',p:'设置坐席工作台，对坐席自身业务成绩、待办事项一目了然'}
          ],
          [//监控及报表
            {title:'客服质量监控',p:'坐席工位图、分机状态监控，提供班长监听、强插、强拆功能，用户队列排队情况监控'},
            {title:'业务占比监控',p:'打通业务系统，监控从通话到成单的比例'},
            {title:'工单监控',p:'工单中央监控，定时统计及时告警'},
            {title:'大屏监控',p:'多维度数据集中可视化展示'},
            {title:'全渠道坐席监控',p:'电话、网聊等全媒体坐席状态监控'},
            {title:'报表统计分析',p:'多渠道多维度数据组合展示并灵活导出'}
          ],
          [//系统集成
            {title:'电话语音平台',p:'支持与市场主流话务平台对接集成。'},
            {title:'核心系统',p:'支持与客户核心系统对接集成。'},
            {title:'全媒体网聊集成',p:'支持包含但不仅限于官网、微信、APP、微博等渠道接入，用户可以自由选择自己需要的渠道。'},
            {title:'录音系统',p:'支持与第三方录音对接集成。'},
            {title:'IVR系统',p:'支持与第三方IVR系统对接集成。'},
            {title:'短信、邮箱集成',p:'支持与第三方短信平台、邮件系统集成'}
          ],
          [//智能化赋能
            {title:'智能IVR',p:'语音识别客户意图，智能导航'},
            {title:'智能坐席辅助',p:'话术地图全链路指引客服对话'},
            {title:'智能质检',p:'自动根据规则对会话结果检验打分'},
            {title:'智能陪练',p:'模拟人工对客服进行真实场景考核'},
            {title:'智能催收',p:'多节点多维度自动催收大幅提升回款率'},
            {title:'智能营销',p:'识别客户意向差异化营销，大幅提升成单率'}
          ]
        ]
      },//服务
      solutionData:{
        title:'行业解决方案',
        main:[
          {title:'企业通用',text:'提供企业400/800服务热线与CRM系统，具体功能包含：IVR语音导航、智能IVR、预测外呼、智能外呼、排班管理、绩效管理、监控中心、工单系统、文本机器人、智能知识库、智能质检、智能培训等服务'},
          {title:'保险',text:'寿险、财险公司的服务热线，提供保险查询、投诉受理、接报案、保单信息查询（与核心业务系统集成）、客户回访等服务。'},
          {title:'政府',text:'各种政府的服务热线，包括12345市长热线、12333社保热线、12315工商热线，以及国税、地税、环卫、交通局等各种政府热线，主要功能包含：政策咨询服务知识库、便民热线服务、投诉受理和部门间流转、满意度调查、客户回访、统计分析等。'},
          {title:'汽车',text:'汽车行业的400/800热线，提供有车辆信息管理、联系人管理、车辆服务信息查询、信息咨询、投诉服务、经销商查询、技术案例库、知识库、迎新电话、满意度调查、服务回访等。'},
          {title:'制造',text:'各类制造行业的服务热线，提供B2B或B2C混合服务能力，提供对核心业务系统多种方式的快速集成能力，提供短信、邮件、传真、自动语音、人工等多种服务手段，提供内部流程化的，基于目标设定的，可灵活定制的绩效考评手段，提供业务咨询，网点咨询，产品咨询，快速的知识检索，服务请求受理，派单，服务跟踪，用户满意度回访及调查，产品或服务的市场调查，各类统计分析等等业务功能。'},
          {title:'港口',text:'港口服务热线，提供短信、邮件、传真、自动语音、人工等多种服务手段，进行海运物流、船舶代理、码头综合业务等的业务查询和受理，提供各码头作业公司当日的重要信息和货物集港动态，船舶动态、天气潮汐、票务信息等等信息的查询，提供投诉建议工单的受理，转派工单及监督的功能，提供服务跟踪，客户意见征询，各类统计分析等等业务功能。提供对城市公共交通信息等外部信息源和业务系统的快速集成能力。'},
        ],
        contentText:'提供企业400/800服务热线与CRM系统，具体功能包含：IVR语音导航、智能IVR、预测外呼、智能外呼、排班管理、绩效管理、监控中心、工单系统、文本机器人、智能知识库、智能质检、智能培训等服务'
      },//行业解决方案
      liaisonData:{
        title:'过河兵，专注联络中心CRM',
        main:{
          leftTop:{title:'专业性',content:'深耕行业呼叫中心业务与集成业务解决方案'},
          leftBot:{title:'系统对接',content:'通过配置工具实现对接，无需代码开发，快速上线'},
          rightTop:{title:'全媒体接入',content:'客户信息页面与后台数据统一，无需多页面或系统切换，提高工作效率'},
          rightBot:{title:'业务变更维护成本低',content:'完善的配置工具交付，使业务变更时实施周期短、维护成本低'},
        }
      },//四块
      footerData:{
        telData: [
          {name:'牟伟军',email:'kevinmou@elitecrm.com',tel:'18621991973'},
          {name:'王强',email:'wangqiang@elitecrm.com',tel:'13911234299 18600056673'},
          {name:'任超',email:'rexren@elitecrm.com',tel:'13901604142'},
          {name:'褚明钟',email:'kenchu@elitecrm.com',tel:'13564683252'},
          {name:'宋跃鹏',email:'stevensong@elitecrm.com',tel:'18811030696'},
          {name:'邹宏宇',email:'harryzou@elitecrm.com',tel:'18628190300'}
        ],
        fooText:'版权所有© 上海过河兵软件科技有限公司 · 上海过河兵电子商务有限公司    2001-2016 沪ICP备07015997号-1     沪公网安备 31010402001297号',
        aboutText:`
            <p>过河兵专注于从事于客户服务中心，即呼叫中心相关软件产品开发和业务系统实施服务平台。助企业有效提高客户服务水准，提高客户忠诚度；充分利用现有的客户资料，为企业获取更多的商机，使企业在日趋激烈的市场竞争中赢得并巩固其市场地位。</p>
            <p>2021年3月10日，<span style="color:#5099FC;cursor: pointer;">容联云</span>(纽交所：RAAS)宣布收购过河兵科技。收购完成后，双方将在产品、市场、渠道等层面进行深度融合。基于过河兵在联络中心、移动销售CRM领域的领先优势，以及容联云丰富的全产品云通讯和行业客户服务经验，共同打造串联企业生产管理、市场营销、运营服务的全生命周期SaaS产品，输出高效的场景化智能云通讯解决方案，助力政府、企业等组织机构数字化改造升级。</p>
        `
      },
      emailSVG:`<svg t="1627611171639" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2264" width="16" height="16"><path d="M153.237 163.111H868c48.811 0 88.72 38.476 89.333 85.854L510.874 491.483 64.314 249.17c0.409-47.48 40.01-86.059 88.923-86.059z m-88.924 178.87l-0.409 429.063c0 47.788 40.215 86.877 89.333 86.877H868c49.118 0 89.333-39.09 89.333-86.877V341.777L521.312 573.039a22.628 22.628 0 0 1-21.387 0L64.313 341.98z m0 0" p-id="2265" fill="#979DAE"></path></svg>`,
      nameSVG:`<svg t="1627611492997" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3125" width="16" height="16"><path d="M847.6 717.4c-54.1-25.4-134.4-90.9-253.2-113.3 30.4-34.4 53.4-88.1 77.1-151.8 13.7-36.9 11.4-68.3 11.4-113.1 0-33.1 5.9-86.2-1.9-115.4C654.8 125.2 588.5 98 510.9 98c-77.7 0-144 27.3-170.2 126.1-7.7 29.1-1.8 82.1-1.8 115.1 0 44.9-2.3 76.4 11.5 113.4 23.8 64 46.5 117.7 76.8 151.9-117.9 22.9-197.6 87.8-251.3 113.2C64.6 770 64 827.3 64 827.3v97.4l895.7-0.1v-97.3s-0.5-57.5-112.1-109.9z m0 0" p-id="3126" fill="#979DAE"></path></svg>`,
      addressSVG:`<svg t="1627611710589" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4040" width="16" height="16"><path d="M512 950.857c-73.143-73.143-365.714-256-365.714-512a365.714 365.714 0 1 1 731.428 0c0 256-292.571 438.857-365.714 512z m0-365.714a146.286 146.286 0 1 0 0-292.572 146.286 146.286 0 0 0 0 292.572z" p-id="4041" fill="#979DAE"></path></svg>`,
      ybSVG:`<svg t="1627611792402" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5043" width="16" height="16"><path d="M1010.816 156.032 1010.816 107.328l-64.512 0c-0.96 26.944-22.912 48.576-50.048 48.576-27.264 0-49.28-21.632-50.112-48.576l-53.76 0c-0.896 26.944-22.848 48.576-50.112 48.576-27.2 0-49.216-21.632-50.048-48.576l-53.76 0C637.568 134.272 615.488 155.904 588.352 155.904c-27.2 0-49.216-21.632-50.112-48.576L484.48 107.328C483.648 134.272 461.632 155.904 434.496 155.904c-27.136 0-49.216-21.632-50.112-48.576L330.624 107.328C329.664 134.272 307.712 155.904 280.512 155.904c-27.2 0-49.216-21.632-50.112-48.576l-53.76 0C175.808 134.272 153.792 155.904 126.592 155.904c-27.136 0-49.216-21.632-50.048-48.576l-63.36 0 0 48.576c27.776 0 50.24 22.528 50.24 50.176 0 27.84-22.464 50.24-50.24 50.24l0 43.072c27.776 0 50.24 22.464 50.24 50.24S40.896 399.936 13.12 399.936L13.12 442.88c27.776 0 50.24 22.464 50.24 50.24 0 27.712-22.464 50.24-50.24 50.24l0 43.008c27.776 0 50.24 22.528 50.24 50.24 0 27.712-22.464 50.24-50.24 50.24l0 42.944c27.776 0 50.24 22.592 50.24 50.24 0 27.904-22.464 50.368-50.24 50.368l0 55.424 63.232 0c0.064-27.776 22.528-50.24 50.24-50.24 27.84 0 50.304 22.528 50.304 50.24l53.376 0c0-27.776 22.464-50.24 50.304-50.24 27.776 0 50.176 22.528 50.24 50.24l53.44 0c0-27.776 22.528-50.24 50.24-50.24 27.648 0 50.24 22.528 50.304 50.24l53.376 0c0-27.776 22.464-50.24 50.24-50.24 27.712 0 50.176 22.528 50.176 50.24l53.376 0c0.192-27.776 22.656-50.24 50.304-50.24 27.776 0 50.176 22.528 50.368 50.24l53.312 0c0-27.776 22.592-50.24 50.304-50.24 27.648 0 50.176 22.528 50.176 50.24l64.384 0 0-55.616c-26.752-1.216-48.128-23.04-48.128-50.176 0-26.944 21.376-48.896 48.128-50.048l0-43.392c-26.752-1.088-48.128-22.976-48.128-49.984 0-27.072 21.376-48.96 48.128-50.048L1010.816 543.232c-26.752-1.152-48.128-23.04-48.128-50.112 0-27.072 21.376-48.896 48.128-50.048L1010.816 399.68c-26.752-1.088-48.128-22.976-48.128-50.048 0-27.008 21.376-48.896 48.128-50.048L1010.816 256.128c-26.752-1.088-48.128-22.912-48.128-50.048C962.688 179.072 984.064 157.248 1010.816 156.032zM883.456 758.528 140.544 758.528 140.544 234.752l742.912 0L883.456 758.528z" p-id="5044" fill="#979DAE"></path></svg>`,

    }
  },
  methods:{
    handleClick(type){
      this.sService = type;
    },
    handleClickHrLi(val){
      this.hrLiActive = val;
    },
    handleClickSolution(val,txt){
      this.solutionActive = val;
      this.solutionData.contentText = txt;
    },
    handleHeaderClick(e){
      let b = this.$refs[`logoRightLi${e}`][0];
      let str = b.href;
      let num = str.lastIndexOf('/');
      console.log(num);
    },
  }
}
</script>
